// SeraPark — Site content (static)
// Collections + hero images extracted from the Anka Seramik 2026 catalogue.
import { catalogCollections } from "./collections";
export const collections = catalogCollections;

export const company = {
  name: "SeraPark",
  legalName: "SeraPark Yapı Malzemeleri",
  tagline: "Zamansız yüzeyler. Kusursuz mekânlar.",
  phone: "0532 232 44 14",
  phoneRaw: "+905322324414",
  whatsapp: "https://wa.me/905322324414",
  email: "seraparkyapi@gmail.com",
  address:
    "Paşabağı Mahallesi, Mevlana Caddesi, 63300 Haliliye / Şanlıurfa / Türkiye",
  hours: [
    { day: "Pazartesi – Cuma", time: "08:00 – 19:00" },
    { day: "Cumartesi", time: "08:00 – 18:00" },
    { day: "Pazar", time: "Kapalı" },
  ],
  social: {
    instagram: "https://www.instagram.com/seramikpark.com",
    facebook: "https://www.facebook.com/",
    linkedin: "https://www.linkedin.com/",
    youtube: "https://www.youtube.com/",
  },
  mapEmbed:
    "https://www.google.com/maps?q=Pa%C5%9Faba%C4%9F%C4%B1+Mahallesi%2C+Mevlana+Caddesi%2C+63300+Haliliye+%C5%9Eanl%C4%B1urfa&output=embed",
};

export const categories = [
  {
    slug: "seramik",
    name: "Seramik",
    count: 42,
    description:
      "Duvar ve zeminde form kazanan, dayanıklılığı estetikle birleştiren klasik zamansızlık.",
    image: "/catalog/cement-hero.jpg",
  },
  {
    slug: "porselen",
    name: "Porselen",
    count: 68,
    description:
      "Yüksek yoğunluk, düşük emiş. Sıfırdan tasarlanmış showroom kalitesi.",
    image: "/catalog/vesna-hero.jpg",
  },
  {
    slug: "granit",
    name: "Granit",
    count: 24,
    description:
      "Doğanın en sert yüzeyi, mimarinin en kararlı zemini. Ağır trafik için.",
    image: "/catalog/portoro-hero.jpg",
  },
  {
    slug: "banyo",
    name: "Banyo",
    count: 36,
    description:
      "Su geçirmez lüks. Vitrifiye, armatür ve karo koleksiyonlarıyla eksiksiz banyolar.",
    image: "/catalog/dolomite-hero.jpg",
  },
  {
    slug: "mutfak",
    name: "Mutfak",
    count: 29,
    description:
      "Doğal taşın rafineliği, porselenin dayanıklılığı. Sıcak mutfaklar için soğukkanlı yüzeyler.",
    image: "/catalog/calacatta-hero.jpg",
  },
  {
    slug: "dis-mekan",
    name: "Dış Mekân",
    count: 18,
    description:
      "Anti-slip, dona dayanıklı, 20 mm. Terastan yürüyüş yoluna, güneşten kışa.",
    image: "/catalog/riva-hero.jpg",
  },
];

// —— Collections are imported from ./collections at the top of this file (56 items) ——


export const projects = [
  {
    slug: "urla-villa",
    title: "Urla Beach Residence",
    location: "İzmir",
    year: 2024,
    tags: ["Villa", "İç & Dış"],
    image: "/catalog/urla-hero.jpg",
    height: "tall",
  },
  {
    slug: "urfa-boutique-hotel",
    title: "Haliliye Boutique Hotel",
    location: "Şanlıurfa",
    year: 2024,
    tags: ["Otel", "Lobi"],
    image: "/catalog/vesna-hero.jpg",
    height: "short",
  },
  {
    slug: "gaziantep-office",
    title: "GAP Kule Ofisleri",
    location: "Gaziantep",
    year: 2023,
    tags: ["Ofis", "Lobi"],
    image: "/catalog/cement-hero.jpg",
    height: "medium",
  },
  {
    slug: "ankara-loft",
    title: "Çankaya Loft Serisi",
    location: "Ankara",
    year: 2024,
    tags: ["Konut", "Salon"],
    image: "/catalog/calacatta-hero.jpg",
    height: "tall",
  },
  {
    slug: "bodrum-marina",
    title: "Bodrum Marina Rezidans",
    location: "Muğla",
    year: 2023,
    tags: ["Rezidans", "Dış Mekan"],
    image: "/catalog/riva-hero.jpg",
    height: "short",
  },
  {
    slug: "istanbul-penthouse",
    title: "Nişantaşı Penthouse",
    location: "İstanbul",
    year: 2025,
    tags: ["Konut", "Butik"],
    image: "/catalog/portoro-hero.jpg",
    height: "medium",
  },
  {
    slug: "izmir-office",
    title: "Alsancak Ofis Kule",
    location: "İzmir",
    year: 2025,
    tags: ["Ofis", "Lobi"],
    image: "/catalog/sardes-hero.jpg",
    height: "tall",
  },
  {
    slug: "antalya-spa",
    title: "Belek Wellness & Spa",
    location: "Antalya",
    year: 2024,
    tags: ["Otel", "Spa"],
    image: "/catalog/zen-hero.jpg",
    height: "medium",
  },
];

export const posts = [
  {
    slug: "buyuk-format-porselen-nasil-secilir",
    title: "Büyük Format Porselen Nasıl Seçilir?",
    excerpt:
      "120×260 cm dilimler mekâna nasıl derinlik katar? Uygulama, ek yeri ve aydınlatma detayları.",
    category: "Uygulama",
    date: "18 Kasım 2025",
    readTime: "6 dk",
    cover:
      "/catalog/calacatta-hero.jpg",
    author: {
      name: "Mimar Elif Aksoy",
      role: "Ürün Danışmanı",
      avatar:
        "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=200",
    },
    toc: [
      "Format seçimi",
      "Uygulama yüzeyi",
      "Aydınlatmayla ilişki",
      "Bakım ve temizlik",
    ],
    content: [
      "Geniş formatlı porselen dilimler, çağdaş iç mimarinin en dikkat çekici yüzey trendlerinden biri hâline geldi. 120×120, 120×260 hatta 160×320 cm dilimler; ek yerini asgariye indirerek mekâna büyük bir sükûnet katıyor.",
      "Doğru format seçimi mekânın oranıyla başlar. Yüksek tavanlı bir salonda 120×260 cm dilimler tavanın ferahlığıyla konuşurken; küçük bir banyo için 60×120 cm daha uyumlu bir ölçek sağlar.",
      "Aydınlatma, büyük format porselenin karakterini belirleyen ikinci unsurdur. Doğrusal LED şeritler, damar hareketlerini ortaya çıkarır; nokta aydınlatma ise mineral parlaklığı vurgular.",
      "Bakım yönünden büyük dilimlerin en büyük avantajı ek yerinin azalmasıdır. Bu, hijyenik yüzey oranını arttırır ve modern banyo mimarisi için tercih edilme sebeplerinden biridir.",
    ],
  },
  {
    slug: "banyo-tasariminda-yuzey-uyumu",
    title: "Banyo Tasarımında Yüzey Uyumu",
    excerpt:
      "Zemin, duvar ve vitrifiyeyi tek dile bağlamak: minimalizmin altın oranı.",
    category: "Tasarım",
    date: "11 Kasım 2025",
    readTime: "5 dk",
    cover:
      "/catalog/dolomite-hero.jpg",
    author: {
      name: "Mimar Onur Demir",
      role: "Kreatif Direktör",
      avatar:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=200",
    },
    toc: ["Renk paleti", "Doku dengesi", "Aydınlatma", "Aksesuar seçimi"],
    content: [
      "Banyoda yüzey uyumu, mekânın algılanan büyüklüğünü doğrudan etkiler. Aynı tonun mat ve parlak varyasyonlarını yan yana kullanmak, monotonluğu bozmadan derinlik yaratır.",
      "Doğal ışığın kısıtlı olduğu banyolarda açık tonlar tercih edilmelidir; ancak tüm yüzeyleri aynı renkte kaplamak sıkıcı olabilir. Aksan bir duvar veya nişte kontrast bir doku denemek dengeyi kurar.",
      "Aydınlatma katmanlı olmalıdır: tavanda dolaylı ışık, aynada işlevsel LED, zeminde ise atmosferik sıcaklık. Bu üçlü, yüzeylerin karakterini gün içinde farklı biçimlerde ortaya çıkarır.",
      "Aksesuar seçiminde mineral yüzeye uyumlu mat siyah veya fırçalanmış pirinç detaylar öneririz. Metal seçimi, yüzeyin ruhunu tamamlayan sessiz bir imza olur.",
    ],
  },
  {
    slug: "dis-mekan-icin-antislip-porselen",
    title: "Dış Mekân İçin Anti-slip Porselen",
    excerpt:
      "20 mm porselenin donma-çözünme direnci: kışın da güvenli teraslar için mühendislik.",
    category: "Teknik",
    date: "02 Kasım 2025",
    readTime: "4 dk",
    cover:
      "/catalog/riva-hero.jpg",
    author: {
      name: "İnş. Müh. Baran Türk",
      role: "Teknik Danışman",
      avatar:
        "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=200",
    },
    toc: ["Kalınlık avantajı", "Anti-slip sınıfı", "Uygulama yöntemleri"],
    content: [
      "20 mm kalınlığındaki dış mekân porseleni, yüksek yaya trafiğine ve donma-çözünme döngülerine dayanıklıdır. Standart 9 mm iç mekân karolarına göre üç kata kadar mukavemetli sonuçlar verir.",
      "R11 anti-slip sınıfı, ıslak zeminde bile yüksek kayma direnci sağlar. Havuz kenarları, teraslar ve balkonlarda tercih edilmelidir.",
      "Uygulamada üç yöntem öne çıkar: harçlı, kuru çakıl üstüne serbest döşeme ve yükseltilmiş sistemler. Yükseltilmiş sistem, teknik altyapı gerektiren teras uygulamalarında altın standarttır.",
    ],
  },
  {
    slug: "showroom-ziyaretine-nasil-hazirlanilir",
    title: "Showroom Ziyaretine Nasıl Hazırlanılır?",
    excerpt:
      "Doğru soruları sorarak zaman kazanın; katalog, ölçü ve renk paletinizi getirin.",
    category: "Rehber",
    date: "24 Ekim 2025",
    readTime: "3 dk",
    cover:
      "/catalog/vesna-hero.jpg",
    author: {
      name: "SeraPark Ekibi",
      role: "Danışmanlık",
      avatar:
        "https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=200",
    },
    toc: ["Öncesi", "Ziyaret esnası", "Sonrası"],
    content: [
      "Ziyaretiniz öncesinde mekânın kaba planını, ölçülerini ve renk yönelimlerinizi hazır getirin. Kullanmayı planladığınız mobilya ve armatür örnekleri seçimi netleştirir.",
      "Ziyaret sırasında yüzey örneklerini gün ışığında görmek çok önemlidir. Showroom'da doğal ışık alan bölümlerde büyük format panelleri incelemenizi öneririz.",
      "Ziyaret sonrasında seçtiğiniz koleksiyonların 30×30 cm örneklerini yanınıza alın; mekâna götürüp mevcut aydınlatmada kontrol edin.",
    ],
  },
];

export const testimonials = [
  {
    quote:
      "SeraPark ile çalışmak, klasik seramik satıcı ilişkisinden farklı. Mimari projeye entegre bir yaklaşımları var.",
    name: "Mimar Ceren Aksoy",
    role: "CA Studio",
  },
  {
    quote:
      "20 mm terasla ilgili tüm sorularımıza teknik detayla cevap verdiler. Bir yıl sonra hâlâ ilk günkü gibi.",
    name: "Mehmet Yıldız",
    role: "Villa Sahibi",
  },
  {
    quote:
      "Butik otel projemizde her koleksiyondan örnek gönderdiler. Karar almak hiç bu kadar kolay olmamıştı.",
    name: "Elif Bilgin",
    role: "Haliliye Boutique",
  },
];

export const brands = [
  "ANKA SERAMİK",
  "KALEKİM",
  "PENTA ARMATÜR",
  "BY DESSEN MOBİLYA",
];

export const advantages = [
  {
    icon: "Sparkles",
    title: "Showroom Kalitesi",
    text: "8.000 m² üzerinde İtalyan ve Türk premium markaların birlikte sergilendiği tek showroom deneyimi.",
  },
  {
    icon: "Building2",
    title: "Mimari Danışmanlık",
    text: "İç mimarınıza projeye özel yüzey önerisi. Renk paleti, ölçü ve derz planı dahil.",
  },
  {
    icon: "Truck",
    title: "Türkiye Geneli Sevkiyat",
    text: "Kendi filomuz ve anlaşmalı lojistiğimiz ile 48 saat içinde şantiyenizde.",
  },
  {
    icon: "Palette",
    title: "Renk Uyum Servisi",
    text: "Mobilya ve tekstil renklerinize eş yüzeyleri kütüphanemizden seçiyoruz.",
  },
];
